import React from 'react'

const Buy = () => {
  return (
    <div>Buy section</div>
  )
}
export default Buy